<template>
	<div>
		<div class="text-2xl font-bold mb-4">
			Genereaza contractul de executie lucrari
		</div>
		<h5 class="text-base text-gray-500 font-bold uppercase pb-4">
			Detalii suplimentare
		</h5>

		<v-form ref="addContractForm" v-model="contractForm" @submit.prevent="generateContract">
			<v-text-field v-if="oferta_productie.country === 'ro'" v-model="contract_details.denumire" outlined
				:rules="[rules.required]" label="Denumirea generica in contract"></v-text-field>
			<div v-if="!+oferta_productie.firma">
				<hr class="mb-4">
				<div class="font-medium mb-2">Date identificare persoana</div>
				<v-radio-group v-model="tip_document" row mandatory>
					<template v-slot:label>
						<div class="mr-6">Document:</div>
					</template>
					<v-radio label="CI" value="CI" color="teal"></v-radio>
					<v-radio label="Alt document" value="ALT" color="teal"></v-radio>
				</v-radio-group>
				<div class="flex gap-4">
					<v-text-field v-model="contract_details.cnp" class="flex-grow-0 w-48" dense outlined
						label="CNP"></v-text-field>
					<div v-if="tip_document == 'CI'" class="flex flex-grow-0 gap-2">
						<v-text-field v-model="contract_details.serie_ci" class="w-40" maxlength="2" dense outlined
							:rules="[rules.required]" label="Serie CI *"></v-text-field>
						<v-text-field v-model="contract_details.numar_ci" class="w-40" maxlength="7" dense outlined
							:rules="[rules.required]" label="Numar CI *"></v-text-field>
					</div>
					<div class="flex flex-grow gap-1" v-else>
						<v-text-field v-model="contract_details.alt_document" class="w-1/2" dense outlined
							:rules="[rules.required]" label="Nume document *"></v-text-field>
						<v-text-field v-model="contract_details.alt_document_nr" class="w-1/2" maxlength="12" dense
							outlined :rules="[rules.required]" label="Numar document *"></v-text-field>
					</div>
				</div>
			</div>
			<hr class="mb-4">
			<div>
				<div class="font-medium mb-4">Adrese si montaj</div>
				<v-text-field v-model="contract_details.adresa" outlined dense :rules="[rules.required]"
					:label="addressLabel">
				</v-text-field>
				<div>
					<v-checkbox v-model="contract_details.alta_locatie" color="teal" class="mt-0"
						label="Alta adresa pentru montaj"></v-checkbox>
					<v-text-field v-if="contract_details.alta_locatie" v-model="contract_details.locatie" outlined dense
						:rules="[rules.required]" label="Adresa montaj *">
					</v-text-field>
				</div>

				<div class="mb-4">
					<v-radio-group v-model="contract_details.finisaj_finalizat" row mandatory>
						<template v-slot:label>
							<div class="mr-6">Este finalizata partea de finisaje?</div>
						</template>
						<v-radio label="DA" :value="true" color="teal"></v-radio>
						<v-radio label="NU" :value="false" color="teal"></v-radio>
					</v-radio-group>
					<div class="font-medium mb-2">Firma montaj</div>
					<v-alert v-if="user.rol === 'partener' && user.departamente.includes('productie')"
						type="info">Contract
						emis de pe <span class="font-bold">partener</span>!</v-alert>
					<v-radio-group v-model="contract_details.montaj_separat" row class="mt-0"
						:rules="[rules.montajRequired]">
						<v-radio label="Montaj pe Cuprolli Manufacturing" :value="false" color="teal"></v-radio>
						<v-radio label="Montaj pe alta firma" :value="true" color="teal"
							:disabled="!next_firma_montaj"></v-radio>
					</v-radio-group>
					<v-alert v-if="!next_firma_montaj" type="warning" dense outlined class="mb-2">
						Nicio firma de montaj disponibila. Verificati pragurile in setari.
					</v-alert>
					<div v-if="contract_details.montaj_separat && next_firma_montaj"
						class="flex items-center gap-2 mb-4">
						<v-icon color="teal">mdi-domain</v-icon>
						<span class="text-sm">Firma montaj alocata: <span class="font-bold">{{
							next_firma_montaj.denumire_firma
								}}</span></span>
						<v-chip v-if="next_firma_montaj.over_threshold" color="orange" small text-color="white">Peste
							prag</v-chip>
						<v-menu offset-y open-on-hover>
							<template v-slot:activator="{ on, attrs }">
								<v-icon small color="grey" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
							</template>
							<v-card class="pa-4" min-width="260">
								<div v-for="firma in firme_montaj" :key="firma.id_firma" class="mb-3">
									<div class="text-sm font-bold mb-1">{{ firma.denumire_firma }}</div>
									<div class="flex justify-between text-xs text-gray-500 mb-1">
										<span>{{ firma.current_turnover | formatRon }}</span>
										<span v-if="firma.turnover_threshold">{{ firma.turnover_threshold | formatRon
											}}</span>
										<span v-else>fara limita</span>
									</div>
									<v-progress-linear
										:value="firma.turnover_threshold ? Math.min(100, (firma.current_turnover / firma.turnover_threshold) * 100) : 0"
										:color="firma.turnover_threshold && (firma.current_turnover / firma.turnover_threshold) >= 1 ? 'red' : firma.turnover_threshold && (firma.current_turnover / firma.turnover_threshold) >= 0.8 ? 'orange' : 'teal'"
										height="4" rounded></v-progress-linear>
								</div>
							</v-card>
						</v-menu>
					</div>
				</div>
			</div>
			<div class="flex flex-row justify-end gap-2">
				<v-btn color="blue-grey" class="uppercase" large dark @click="$emit('closeModal')">Anuleaza</v-btn>
				<v-btn color="teal" class="uppercase" large dark type="submit">
					<v-icon left dark>
						mdi-cloud-upload
					</v-icon>
					Genereaza</v-btn>
			</div>
			<pre v-if="$isDev">
	<!-- {{ user }} -->
</pre>
		</v-form>
	</div>
</template>

<script>

export default {
	name: "AddContractPorductie",
	components: {},
	props: {
		user: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {
			contractForm: false,
			contract_details: {
				denumire: "gard din aluminiu vopsit electrostatic",
				serie_ci: "",
				numar_ci: "",
				alt_document: "",
				alt_document_nr: "",
				cnp: "",
				adresa: this.oferta_address,
				alta_locatie: false,
				montaj_separat: null,
				firma_montaj: null,
				finisaj_finalizat: true,
				locatie: ""
			},
			tip_document: "CI",
			rules: {
				required: value => !!value || 'Câmp obligatoriu',
				montajRequired: value => value !== null && value !== undefined || 'Selectati firma de montaj'
			}
		};
	},
	computed: {
		oferta_productie() {
			return this.$store.getters.currentOfertaProductie;
		},
		activeLabelAdresaContract() {
			if (
				this.oferta_productie.adresa == null ||
				this.oferta_productie.adresa == ""
			) {
				return false;
			} else {
				return true;
			}
		},
		// montaj: {
		// 	get() {
		// 		return !this.oferta_productie.persoana;
		// 	},
		// 	set(val) {
		// 		this.contract_details.montaj_separat = val
		// 		this.contract_details.firma_montaj = val
		// 			? this.firma_montaj_activa.id_firma
		// 			: val;
		// 	}
		// },
		firma_montaj_activa() {
			return this.$store.getters.firma_montaj_activa;
		},
		next_firma_montaj() {
			return this.$store.getters.next_firma_montaj;
		},
		firme_montaj() {
			return this.$store.getters.firme_montaj;
		},
		addressLabel() {
			let str = 'Adresa domiciliu si montaj *'
			if (this.contract_details.alta_locatie) {
				str = 'Adresa domiciliu *'
			}
			return str
		}
	},
	watch: {
		'contract_details.alta_locatie'(newVal) {
			if (!newVal) {
				this.contract_details.locatie = ""
			}
		},
		next_firma_montaj(firma) {
			if (!firma) {
				this.contract_details.montaj_separat = null;
				this.contract_details.firma_montaj = null;
			}
		}
	},
	methods: {
		oferta_address() {
			let address = this.oferta_productie.adresa;
			if (this.oferta_productie.oras != null) {
				address += `, ${this.oferta_productie.oras}`;
			}
			this.contract_details.adresa = address;
		},
		async generateContract() {
			const valid = await this.$refs.addContractForm.validate();

			if (valid) {
				const firma_montaj = this.contract_details.montaj_separat && this.next_firma_montaj
					? this.next_firma_montaj.id_firma
					: null;

				let newContract = {
					client_id: this.oferta_productie.id_client,
					oferta_id: this.oferta_productie.id_oferta,
					oferta_data: this.oferta_productie.data,
					user_id: this.oferta_productie.id_user,
					country: this.oferta_productie.country,
					detalii: JSON.stringify({ ...this.contract_details, firma_montaj }),
				};

				// save Contract
				this.$store.dispatch("addContractProductie", newContract);
				this.$emit('closeModal')
			}
		},
	},
	created: function () {
		this.$store.dispatch("fetchFirmeMontaj");
		this.$store.dispatch("fetchNextFirmaMontaj", this.oferta_productie.id_oferta);
	},
	mounted: function () {
		if (this.next_firma_montaj) {
			this.contract_details.firma_montaj = this.next_firma_montaj.id_firma;
		} else if (this.firma_montaj_activa) {
			this.contract_details.firma_montaj = this.firma_montaj_activa.id_firma;
		}
		if (['at', 'de'].includes(this.oferta_productie.country)) {
			this.contract_details.alt_document = 'Personalausweis'
		}
		if (this.oferta_productie.country === 'hu') {
			this.contract_details.alt_document = 'igazolvány'
		}
		this.oferta_address();
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
